export enum IntegrationType{
    hs = 'hubspot',
    sf = 'salesforce',
}